module.exports = __webpack_public_path__ + "static/media/Webp.net-resizeimage.66810bd4.jpg";